"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUserAttribute;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _storage = require("../utils/storage");

var _storage2 = require("../constants/storage");

function useUserAttribute(getUserAttributes, setUserAttribute, attributeKey) {
  var cacheSeenInWindow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      attributeLoaded = _useState2[0],
      setAttributeLoaded = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hasAttribute = _useState4[0],
      setHasAttribute = _useState4[1];

  var hasSeenStorageKeyRef = (0, _react.useRef)(null);
  var handleSetUserAttribute = (0, _react.useCallback)(function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setUserAttribute(attributeKey, value).catch(function (error) {
      console.error('Unable to set user attribute', error);
    });
    setHasAttribute(value);
  }, [setUserAttribute, attributeKey]);
  (0, _react.useEffect)(function () {
    getUserAttributes([attributeKey]).then(function (_ref) {
      var attributes = _ref.attributes,
          query = _ref.query;
      var attribute = attributes.find(function (_ref2) {
        var key = _ref2.key;
        return key === attributeKey;
      });
      var userId = query.userId;
      var hasAttr = !!(attribute && attribute.value === 'true');

      if (cacheSeenInWindow) {
        hasSeenStorageKeyRef.current = _storage2.LOCAL_STORAGE_KEY + ":user-" + userId + ":" + attributeKey;
        var hasSeenInWindow = !!(0, _storage.getSessionItem)(hasSeenStorageKeyRef.current);
        hasAttr = hasAttr || hasSeenInWindow;
        (0, _storage.setSessionItem)(hasSeenStorageKeyRef.current, true);
      }

      setHasAttribute(hasAttr);
      setAttributeLoaded(true);
    }).catch(console.error);

    if (cacheSeenInWindow) {
      var handleClearSession = function handleClearSession() {
        (0, _storage.removeSessionItem)(hasSeenStorageKeyRef.current);
      };

      window.addEventListener('unload', handleClearSession);
      return function () {
        return window.removeEventListener('unload', handleClearSession);
      };
    }

    return undefined;
  }, [getUserAttributes, attributeKey, cacheSeenInWindow]);
  return [attributeLoaded, hasAttribute, handleSetUserAttribute];
}

module.exports = exports.default;